/**
 * 冒烟测试日志脱敏：隐藏密钥、Token、内网 IP、长对象键中的敏感片段等。
 */
const SENSITIVE_KEY =
  /(api[_-]?key|secret|password|passwd|token|authorization|access[_-]?key|private[_-]?key|cookie|credential)/i;

function maskValue(value: string): string {
  const s = value.trim();
  if (s.length <= 8) return '***';
  return `${s.slice(0, 2)}***${s.slice(-2)}`;
}

function redactString(input: string): string {
  let s = input;
  // Bearer / JWT
  s = s.replace(/\bBearer\s+[A-Za-z0-9._\-+=/]+/gi, 'Bearer ***');
  s = s.replace(/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9._\-]+\.[A-Za-z0-9._\-]+/g, '***jwt***');
  // IPv4
  s = s.replace(/\b(?:\d{1,3}\.){3}\d{1,3}\b/g, (ip) => {
    if (ip.startsWith('127.') || ip === '0.0.0.0') return ip;
    return '***.***.***.***';
  });
  // query secrets
  s = s.replace(
    /([?&](?:api[_-]?key|token|secret|password|access_token|refresh_token)=)([^&\s]+)/gi,
    (_, p1: string) => `${p1}***`,
  );
  // long hex / base64-ish blobs
  s = s.replace(/\b[A-Fa-f0-9]{32,}\b/g, (m) => maskValue(m));
  return s;
}

export function redactForSmokeLog(value: unknown, depth = 0): unknown {
  if (value == null) return value;
  if (depth > 6) return '[…]';
  if (typeof value === 'string') return redactString(value);
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (Array.isArray(value)) return value.map((v) => redactForSmokeLog(v, depth + 1));
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (SENSITIVE_KEY.test(k)) {
        out[k] = typeof v === 'string' ? maskValue(v) : '***';
      } else {
        out[k] = redactForSmokeLog(v, depth + 1);
      }
    }
    return out;
  }
  return String(value);
}

export function formatSmokeDetail(detail: unknown): string {
  try {
    const redacted = redactForSmokeLog(detail);
    if (typeof redacted === 'string') return redacted;
    return JSON.stringify(redacted, null, 2);
  } catch {
    return String(detail);
  }
}
